<div class="ion-padding ev-kiurites">
  <h2><ion-icon name="trash-bin-outline"></ion-icon> Év kiürítése</h2>

  <p *ngIf="!modul" class="halvany">Az év kiürítése a Könyvelés (NAPLO) és a Bérszámfejtés (BÉR) modulban érhető el – válts a megfelelő modulra.</p>

  <ng-container *ngIf="modul">
    <p class="halvany">
      {{ modulNev }}: egy ügyfél kiválasztott évének <b>minden rekordja</b> törlődik a bejelölt kategóriákban.
      A kiürítés előtt mentés készül, amelyből – amíg az évbe nem kerül új adat – visszaállítható.
    </p>

    <div class="ek-valaszto">
      <label>Ügyfél
        <select [(ngModel)]="ugyfelId" (ngModelChange)="frissit()">
          <option *ngFor="let u of ugyfelek" [ngValue]="u.id">{{ u.azonosito ? u.azonosito + ' – ' : '' }}{{ u.nev }}</option>
        </select>
      </label>
      <label>Év
        <select [(ngModel)]="ev" (ngModelChange)="frissit()">
          <option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option>
        </select>
      </label>
    </div>

    <div *ngIf="betolt" class="halvany">Számolás…</div>
    <ion-note *ngIf="hiba" color="danger">{{ hiba }}</ion-note>

    <div class="ek-kategoriak" *ngIf="!betolt && kategoriak.length">
      <label class="ek-kat" *ngFor="let k of kategoriak" [class.ures]="!k.db" [class.jelolt]="k.kivalasztva && k.db">
        <input type="checkbox" [(ngModel)]="k.kivalasztva" [disabled]="!k.db">
        <div class="ek-kat-szoveg">
          <div class="ek-kat-fej"><b>{{ k.cim }}</b><span class="ek-db">{{ k.db ? (k.db | number:'1.0-0') + ' db' : 'nincs adat' }}</span></div>
          <small class="halvany">{{ k.leiras }}</small>
          <small *ngIf="k.db && reszletSzoveg(k, true)" class="ek-reszlet">Törlődik: {{ reszletSzoveg(k, true) }}</small>
          <small *ngIf="k.db && reszletSzoveg(k, false)" class="ek-reszlet mod">Módosul: {{ reszletSzoveg(k, false) }}</small>
        </div>
      </label>
    </div>

    <div class="ek-veszely" *ngIf="!betolt && kategoriak.length">
      <div class="ek-veszely-fej"><ion-icon name="warning-outline"></ion-icon>
        <span *ngIf="kivalasztottak.length"><b>{{ osszesDb | number:'1.0-0' }} tétel</b> törlődik: {{ ugyfelNev }}, {{ ev }}.</span>
        <span *ngIf="!kivalasztottak.length">Nincs kiválasztott, adatot tartalmazó kategória.</span>
      </div>
      <label class="ek-megerosit">A megerősítéshez írd be az ügyfél nevét: <b>{{ ugyfelNev }}</b>
        <input type="text" [(ngModel)]="megerosites" [placeholder]="ugyfelNev" autocomplete="off" [disabled]="!kivalasztottak.length">
      </label>
      <ion-button color="danger" [disabled]="!nevEgyezik || !kivalasztottak.length || fut" (click)="kiurit()">
        <ion-icon slot="start" name="trash-outline"></ion-icon>{{ fut ? 'Folyamatban…' : ev + '. év kiürítése' }}
      </ion-button>
    </div>

    <ng-container *ngIf="korabbiak.length">
      <h3>Korábbi kiürítések</h3>
      <div class="tabla-wrap">
        <table class="lista">
          <thead><tr><th>Időpont</th><th>Év</th><th>Kategóriák</th><th>Törölve</th><th>Ki</th><th></th></tr></thead>
          <tbody>
            <tr *ngFor="let k of korabbiak">
              <td>{{ k.letrehozva }}</td><td>{{ k.ev }}</td><td>{{ kategoriaNevek(k.kategoriak) }}</td>
              <td>{{ darabSzoveg(k.darabszam) }}</td><td>{{ k.ki || '—' }}</td>
              <td class="jobb">
                <span *ngIf="k.visszaallitva" class="halvany">visszaállítva {{ k.visszaallitva }}</span>
                <ion-button *ngIf="!k.visszaallitva" size="small" fill="outline" [disabled]="fut" (click)="visszaallit(k)">
                  <ion-icon slot="start" name="arrow-undo-outline"></ion-icon>Visszaállítás</ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ng-container>
</div>
